<template>
  <div>
    <div class="header-section" id="headerSection">
      <div class="logo">
        <img :src="require('@/assets/Yep-Logo-Hex.png')" />
      </div>
      <div class="container">
        <div class="section-wrap">
          <div class="section-title">
            <h2>Company Presence Checker</h2>
          </div>
          <div class="form">
            <form @submit.prevent="capture" method="POST">
              <input
                v-model="locationName"
                type="text"
                id="name"
                name="name"
                placeholder="Business Name"
                required
              />
              <input
                v-model="Address"
                type="text"
                id="address"
                name="address"
                placeholder="Street Address"
                required
              />
              <input
                v-model="City"
                type="text"
                id="city"
                name="city"
                placeholder="City"
                required
              />
              <input type="submit" value="Check Now" />
            </form>
          </div>
          <div v-if="ShowMessage" class="mt-2">
            <span class="error-message">
              An Error Occurred Please Try Again!
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
export default {
  name: "UserInput",
  data() {
    return { locationName: "", Address: "", City: "" };
  },
  props: {
    ShowMessage: {
      type: Boolean,
    },
  },
  methods: {
    capture() {
      !this.ShowMessage;
      this.locationName = this.locationName || "";
      this.Address = this.Address || "";
      this.City = this.City || "";
      if (this.locationName === "" || this.Address === "" || this.City === "") {
        return;
      }
      this.emitToParent({
        locationName: this.locationName,
        Address: this.Address,
        City: this.City,
      });
    },
    emitToParent(value) {
      this.$emit("childToParent", value);
    },
  },
};
</script>

        <style>
</style>